import { omit, sortBy, toArray } from 'lodash';

/**
 * Catégories triées sur `order` (colonne Ordre) : /api/category renvoie une map
 * indexée par id, toArray suivrait l'ordre des ids.
 */
export const getOrderedCategories = state =>
    sortBy(toArray(omit(state.category.categories, 'loading')), 'order');



// WEBPACK FOOTER //
// ./src/services/category/selector.js